import { toast } from 'react-toastify'


toast.configure({
	style: {
		fontSize: "18px"
	},
	limit: 4
})

export const showToast = (message, type) => {
	switch (type) {
		case 'success':
			toast.success(message);
			break;
		case 'warn':
			toast.warn(message);
			break;
		case 'error':
			toast.error(message);
			break;
		default:
			toast.info(message);
	}
};
